import React from 'react';
import { parseProps } from './@uteis';

const ListItem = (_props) => {
  const props = parseProps(_props);

  const attr = {
    selected: props.selected,
    active: props.active,
    divider: props.divider,
    href: props.href,
    disabled: props.disabled,
    'data-all': props['data-all'],
    highlighted: props.highlighted,
    title: props.title,
  };

  let classes = 'item ';
  if (props.classes) {
    classes += props.classes;
  }

  const supportRight = !props.supportRight ? null : (
    <div className="support">{props.supportRight}</div>
  );

  const supportLeft = !props.supportLeft ? null : (
    <div className="support">{props.supportLeft}</div>
  );

  const component = 'button' in props ? (
    <button className={classes} {...attr} type="button">
      {supportLeft}
      <div className="content">{props.children}</div>
      {supportRight}
    </button>
  ) : (
    <div className={classes} {...attr}>
      {supportLeft}
      <div className="content">{props.children}</div>
      {supportRight}
    </div>
  );

  return component;
};

export default ListItem;
